import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

/**
 * RoleGuard - Protege las rutas de reservas, permitiendo acceso solo a
 * usuarios con rol 'admin' o 'superadmin'.
 */
@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.authenticationService.check().subscribe({
      next: (data) => {
        if (!data?.success) {
          this.router.navigate(['/']);
          return false;
        }
        const roles: string[] = data.data.roles.map((r: any) => r.name);
        if (!roles.includes('admin') && !roles.includes('superadmin')) {
          this.router.navigate(['/home']);
          return false;
        }
        return true;
      },
      error: () => {
        this.router.navigate(['/']);
        return false;
      },
    });
  }
}
